export const IMAGE_WIDTH = 1600;
export const AD_TIMEOUT = 5000;
export const TALK_ITEM_HEIGHT = 120;
export const AD_HEIGHT = 280;
export const SEE_ALL_LINK_HEIGHT = 60;
export const RIGHT_COLUMN_PADDING = 40;
